import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/medical-equipment";

export const pagingMedicalEquipment = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getMedicalEquipmentById = (medicalEquipmentId) => axios.get(API_PATH + "/get-by-id/" + medicalEquipmentId);

export const saveOrUpdateMedicalEquipment = medicalEquipment => axios.post(API_PATH + "/save", medicalEquipment);

export const deleteMedicalEquipment = medicalEquipmentId => axios.delete(API_PATH + '/mark-delete/' + medicalEquipmentId);

